// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"135":"rich-text","577":"json-editor"}[chunkId] || chunkId) + "." + {"18":"f9f5c044","135":"30b2ceb7","239":"ea951353","577":"b42341e6"}[chunkId] + ".chunk.js";
};